module.exports = require('./helpers/bundle-url').getBundleURL('9Iv90') + "logo-dark.eefe0b7f.svg";